import { createContext, useContext } from "react";
import { Location } from "react-router";

type UseNavigate = Location | null;

export const LastLocationContext = createContext<UseNavigate>(null);

export const useLastLocation = () => useContext(LastLocationContext);
